/**
 * @generated SignedSource<<982c324b2465f44e22128f5709dfdd89>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraVersionStatus = "ARCHIVED" | "RELEASED" | "UNRELEASED" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type versionMenu_softwareBacklog_VersionMenuContent$data = ReadonlyArray<{
  readonly node: {
    readonly name: string;
    readonly project: {
      readonly projectId: string;
    };
    readonly status: JiraVersionStatus;
    readonly versionId: string;
  };
  readonly " $fragmentSpreads": FragmentRefs<"versionMenuItem_softwareBacklog">;
  readonly " $fragmentType": "versionMenu_softwareBacklog_VersionMenuContent";
}>;
export type versionMenu_softwareBacklog_VersionMenuContent$key = ReadonlyArray<{
  readonly " $data"?: versionMenu_softwareBacklog_VersionMenuContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"versionMenu_softwareBacklog_VersionMenuContent">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "versionMenu_softwareBacklog_VersionMenuContent",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraVersion",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "versionId"
            },
            "action": "THROW",
            "path": "node.versionId"
          },
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "name"
            },
            "action": "THROW",
            "path": "node.name"
          },
          {
            "kind": "RequiredField",
            "field": {
              "kind": "ScalarField",
              "name": "status"
            },
            "action": "THROW",
            "path": "node.status"
          },
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "JiraProject",
              "kind": "LinkedField",
              "name": "project",
              "plural": false,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "kind": "ScalarField",
                    "name": "projectId"
                  },
                  "action": "THROW",
                  "path": "node.project.projectId"
                }
              ]
            },
            "action": "THROW",
            "path": "node.project"
          }
        ]
      },
      "action": "THROW",
      "path": "node"
    },
    {
      "kind": "FragmentSpread",
      "name": "versionMenuItem_softwareBacklog"
    }
  ],
  "type": "JiraVersionEdge"
};

(node as any).hash = "a4cdeffafe39db4bddd6ce699b40af53";

export default node;
